/**
 * 递归删除对象中空值对应的属性，返回精减后的对象
 * @param bean 待删除空值属性的对象
 */
export function deleteEmptyAttrKey(bean) {
  if (Object.keys(bean).length === 0) {
    return;
  }
  for (const key in bean) {
    // console.log((key + ' : ' + bean[key]), '循环', !(bean[key] instanceof Array) && typeof bean[key] === 'object', !bean[key] || bean[key] === 'undefined');
    // 是否为对象
    const isObject = !(bean[key] instanceof Array) && typeof bean[key] === 'object';
    // 数据是否为空
    const isEmpty = bean[key] === null || bean[key] === undefined || bean[key] === '' || bean[key] === 'undefined';
    if (isEmpty || (isObject && Object.keys(bean[key]).length === 0)) {
      delete bean[key];
      continue;
    }

    if (isObject) {
      deleteEmptyAttrKey(bean[key]);
    }
  }
}
